import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";
let newsletterSubscribers = () => import(/* webpackChunkName: "newsletter" */ '@/views/newsletter/Subscribers');
let newsletterIndex = () => import(/* webpackChunkName: "newsletter" */ '@/views/newsletter/Index');
let newsletterCreate = () => import(/* webpackChunkName: "newsletter" */ '@/views/newsletter/Create');
let newsletterEdit = () => import(/* webpackChunkName: "newsletter" */ '@/views/newsletter/Edit');
let newsletterShow = () => import(/* webpackChunkName: "newsletter" */ '@/views/newsletter/Show');


export default [
    ...prefix("/newsletter",[
        {
            path: "list",
            name: "newsletter.index",
            component: newsletterIndex,
            meta: {
                middleware: web,
                permissions: ['newsletters:viewAny'],
                title: "خبرنامه ها"
            }
        },
        {
            path: "subscribers",
            name: "newsletter.subscribers",
            component: newsletterSubscribers,
            meta: {
                middleware: web,
                permissions: ['newsletter-subscribers:viewAny'],
                title: "مشترکین خبرنامه"
            }
        },
        {
            path: "create",
            name: "newsletter.create",
            component: newsletterCreate,
            meta: {
                middleware: web,
                permissions: ['newsletters:create'],
                title: "ارسال خبرنامه"
            }
        },
        {
            path: ":message",
            name: "newsletters.show",
            component: newsletterShow,
            meta: {
                middleware: web,
                permissions: ['newsletters:viewAny', 'newsletters:viewSelfRecords'],
                title: "نمایش خبرنامه   "
            }
        },
        {
            path: ":message/edit",
            name: "newsletters.edit",
            component: newsletterEdit,
            meta: {
                middleware: web,
                permissions: ['newsletters:updateAny', 'newsletters:updateSelfRecords'],
                title: "ویرایش خبرنامه "
            }
        },

    ])
]